module.exports = __webpack_public_path__ + "static/media/agenda-icon.1317758a.png";